import { MobileAddSymbolToBasketComponent } from './../mobile-add-symbol-to-basket/mobile-add-symbol-to-basket.component';
import { NgbModal, NgbModalRef, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

import { ISymbolBase } from "../../../interfaces/ISymbolBase";

import { addsymbolstobasketModal } from "./addsymbolstobasket.component";

export function ShowAddToBasketModal(
    modalService: NgbModal,
    symbols: ISymbolBase,
    symbolsList: string[],
    basketId: number, mobileMode = 'desktop') {
    const mobile = mobileMode != 'desktop';
    const component = mobile? MobileAddSymbolToBasketComponent: addsymbolstobasketModal;
    const windowClass = "dark-modal" + (mobile? ' mobile': '');
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: "lg"
    };
    let m: NgbModalRef = modalService.open(component, opt);
    let modal = <addsymbolstobasketModal>m.componentInstance;
    modal.symbolsList = symbolsList;
    modal.symbols = Object.assign({}, symbols);
    return modal;
}